module.exports = __webpack_public_path__ + "img/why-us-card-img-2.8b5561a1.jpg";